import React from "react";
import { PageHeader } from "react-bootstrap";
import PasswordGenerator from "../components/PasswordGenerator";
import "./PasswordGeneratorPage.css";

export default function PasswordGeneratorPage() {
  return (
    <div className="PasswordGeneratorPage">
      <PageHeader>Password Generator</PageHeader>
      <p className="description">
        Generate strong, random passwords with customizable options. 
        Use this tool to create secure passwords for your accounts.
      </p>
      <PasswordGenerator />
    </div>
  );
}
